import styled, { css } from "styled-components/macro";
import { colors, iconSize } from "shared/styles/constants";
import { hoverFocus } from "shared/styles/defaults";

interface PasswordIconProps {
  isHidden?: boolean;
}

export const PasswordIcon = styled.button<PasswordIconProps>`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  width: ${iconSize.l};
  height: ${iconSize.l};

  cursor: pointer;

  ${hoverFocus.defaultFocus};

  ${({ isHidden }) =>
    isHidden &&
    css`
      &::after {
        content: "";
        position: absolute;

        width: ${iconSize.xl};

        border-top: 2px solid ${colors.grey4};
        transform: rotate(-45deg);
      }
    `};

  svg {
    position: absolute;

    &:hover {
      color: ${colors.grey1};
    }
  }
`;
